import { useAuthActions } from "@frontegg/react";
import { LogOut } from "lucide-react";

interface DrawerFooterProps {
  isOpen: boolean;
}

export default function DrawerFooter(props: DrawerFooterProps) {
  const { logout } = useAuthActions();

  const handleLogout = () => {
    // const logoutUrl = `/oauth/logout?post_logout_redirect_uri=${window.location.origin}`;
    // window.location.assign(logoutUrl);
    logout();
  };

  return (
    <div className="mt-[10px]">
      <div className={`logout-btn ${props?.isOpen ? "mb-[30px]" : ""} `}>
        <p
          className={`line w-full ${
            props?.isOpen ? "" : "hidden"
          } h-[5px] rounded-full border-[#1e264569] border-solid border-[1px]`}
        ></p>
        <button
          onClick={handleLogout}
          className={`flex h-[36px] transition-all duration-300 group items-center text-[#DDEBFF] hover:bg-[#0193F8] hover:font-[400] hover:text-[#05050F] ${
            props?.isOpen
              ? "my-[0.8rem] rounded-[12px]"
              : "flex items-center justify-center my-0 h-[50px] rounded-[10px]"
          } px-4 text-white w-full text-[15px]`}
        >
          <LogOut
            className={`${
              props?.isOpen ? "mr-3" : "text-[#DDEBFF]"
            } group-hover:text-[#042849]`}
            size={18}
          />{" "}
          {props?.isOpen ? <span>Logout</span> : ""}
        </button>
        <p
          className={`line w-full h-[5px] ${
            props?.isOpen ? "" : "hidden"
          } rounded-full border-[#1e264569] border-solid border-[1px]`}
        ></p>
      </div>
      <p
        className={`text-[#6B96D680] text-[12px] leading-[16px] font-[200] ${
          props?.isOpen ? "" : "hidden"
        }`}
      >
        <span className="whitespace-nowrap">© FixFinder Inc.</span>
        <br />
        <span className="whitespace-nowrap">All Rights Reserved.</span>
      </p>
    </div>
  );
}
